export const createDownloadLink = (
  data: Blob,
  fileName: string,
) => {
    const newURL = window?.URL?.createObjectURL?.(new Blob([data]));
    const link = document.createElement('a');
    link.href = newURL;
    const docType = data.type.split('/')[1];
    link.setAttribute('download', `${fileName}.${docType}`);
    return link as HTMLElement;
};
